import React from 'react';
import { FadeIn } from '../components/FadeIn';
import { CtaButton } from '../components/CtaButton';
import { buildCheckoutUrl, handleCheckoutClick } from '../utils/tracking';
import { LockIcon, MailIcon, CreditCardIcon } from 'lucide-react';
export function FinalCtaSection() {
  return <section className="min-h-[90vh] flex items-center justify-center px-6 py-20 relative overflow-hidden" data-id="element-173">
      {/* Deep dark gradient background */}
      <div className="absolute inset-0 bg-gradient-to-b from-midnight via-[#0a1520] to-black z-0" data-id="element-174" />

      {/* Subtle red glow at bottom */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-crimson/5 blur-[100px] pointer-events-none z-0" data-id="element-175" />

      <div className="max-w-4xl mx-auto text-center relative z-10 flex flex-col items-center" data-id="element-176">
        <FadeIn data-id="element-177">
          <h2 className="font-playfair text-4xl md:text-6xl lg:text-7xl font-bold text-warmwhite mb-8 leading-tight" data-id="element-178">
            The Next Time Anger Takes Over —<br data-id="element-179" />
            <span className="text-rosegold" data-id="element-180">Will You Have A Way Out?</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-181">
          <div className="font-inter text-lg md:text-xl text-lavender space-y-4 mb-12 max-w-2xl mx-auto" data-id="element-182">
            <p data-id="element-183">Or will it be the same story again?</p>
            <p data-id="element-184">
              The same regret. The same apology. The same promise to yourself
              that 'next time will be different.'
            </p>
            <p className="font-semibold text-warmwhite pt-4" data-id="element-185">
              Next time is now. And it's $6.37.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} className="w-full flex flex-col items-center" data-id="element-186">
          <CtaButton text="YES — Give Me The Anger Circuit Breaker →" href={buildCheckoutUrl('https://pay.hotmart.com/E105448579Q?bid=1776547527273')} onClick={e => handleCheckoutClick(e, 'https://pay.hotmart.com/E105448579Q?bid=1776547527273')} strongPulse={true} className="mb-8 w-full md:w-auto md:min-w-[500px] text-lg py-5" data-id="element-187" />

          <div className="flex flex-col items-center space-y-3 text-softgray text-sm font-inter mb-12" data-id="element-188">
            <span className="flex items-center text-warmwhite font-medium" data-id="element-189">
              <span className="text-rosegold mr-2" data-id="element-190">⚡</span> Instant access sent
              to your email
            </span>
            <div className="flex items-center space-x-4" data-id="element-191">
              <span className="flex items-center" data-id="element-192">
                <LockIcon className="w-4 h-4 mr-1.5" data-id="element-193" /> Secure payment
              </span>
              <span className="text-white/20" data-id="element-194">•</span>
              <span className="flex items-center" data-id="element-195">7-day guarantee</span>
            </div>
            <span className="flex items-center" data-id="element-196">
              <CreditCardIcon className="w-4 h-4 mr-1.5" data-id="element-197" /> One-time payment of
              $6.37 — no subscriptions
            </span>
          </div>

          <p className="font-inter text-xs text-softgray/60 italic" data-id="element-198">
            Join 2,000+ women who chose to take control.
          </p>
        </FadeIn>
      </div>
    </section>;
}